export class ArticuloModel {

  artId: number;
  artDescripcion: string;
  artUndStock: string;
  artCodigoInterno: string;
  artEstado: number;
  artCont: string;

  constructor({
                artId,
                artDescripcion,
                artUndStock,
                artCodigoInterno,
                artEstado,
                artCont
              }) {
    this.artId = artId;
    this.artDescripcion = artDescripcion;
    this.artUndStock = artUndStock;
    this.artCodigoInterno = artCodigoInterno;
    this.artEstado = 1;
    this.artCont = (artCont === null) ? '' : artCont;
  }

}
